<template>
    <div class="payment-plan">
        <div class="left-side">
            <div class="side-info">
                <div class="side-title"><h3>{{ paymentPage.payment_plan.title }}</h3></div>
                <div class="side-desc"><p v-for="item in paymentPage.payment_plan.desc">{{ item.text }}</p></div>
                <button class="btn-more" @click="openContactsFormModal('call-page-get', 'payment-types', 'Блок рассрочки')">
                    <span>{{paymentPage.payment_plan.btn_consult}}</span>
                    <svgIcon name="arrow-right" class="icon-right-arrow"/>
                </button>
            </div>
            <div class="side-pic" :style="!isMobileChecker ? 'background-image: url(' + paymentPage.payment_plan.img + ')' : 'background-image: url(' + paymentPage.payment_plan.img_mobile + ')'"></div>
            
        </div>
        <div class="right-side">
            <div class="plan-list">
                <div class="list-item" v-for="item in paymentPage.payment_plan.cards_desc">
                    <strong>{{ item.title }}</strong>
                    <p>{{ item.desc }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'payment-plan',
        components: {
            svgIcon,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Рассрочка от DIAL',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            paymentPage: 'loadPaymentPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            openContactsFormModal(param, page, block) {
                this.$store.commit('formGlobalParam_set', param);
                this.$store.commit('formGlobalDataModal_set', {'page' : page, 'block' : block});
                this.$store.commit('formModalContainerOpen');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/payment-page/payment-plan.scss';
    @import '@/styles/components/payment-page/respond/payment-plan-respond.scss';
    // @import '@/styles/components/about-page/respond/awards-section-respond.scss';
</style>